var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgValue21(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 99,
    viewBox: "0 0 100 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9655 68.2759H37.5517V71.6897H40.9655V68.2759Z",
    fill: "#F68C33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8621 68.2759H61.4483V71.6897H64.8621V68.2759Z",
    fill: "#F68C33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2069 58.0345H47.7931V61.4483H54.6207V58.0345H51.2069Z",
    fill: "#F68C33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.372 47.7931H0V54.6207H37.195C33.8461 52.895 30.8658 50.5719 28.372 47.7931Z",
    fill: "#F68C33"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3793 92.1724C44.3793 95.9378 47.4415 99 51.2069 99C54.9723 99 58.0345 95.9378 58.0345 92.1724V64.8621H44.3793V92.1724Z",
    fill: "#F68C33"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5684 51.2069L90.4655 44.3793V47.7931H51.2069C39.9124 47.7931 30.7241 38.6049 30.7241 27.3103C30.7241 16.0158 39.9124 6.82759 51.2069 6.82759C62.5014 6.82759 71.6896 16.0158 71.6896 27.3103C71.6896 34.4298 68.0335 40.7078 62.5048 44.3793H72.4765C76.3648 39.5386 78.5172 33.5149 78.5172 27.3103C78.5172 12.2521 66.2651 0 51.2069 0C36.1486 0 23.8965 12.2521 23.8965 27.3103C23.8965 42.3686 36.1486 54.6207 51.2069 54.6207H90.4655V58.0345L99.5684 51.2069Z",
    fill: "#F68C33"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2069 10.2414C41.7951 10.2414 34.1379 17.8985 34.1379 27.3104C34.1379 36.7222 41.7951 44.3793 51.2069 44.3793C60.6187 44.3793 68.2759 36.7222 68.2759 27.3104C68.2759 17.8985 60.6187 10.2414 51.2069 10.2414ZM43.8911 34.4776L41.452 36.8656C38.9377 34.2984 37.5517 30.9051 37.5517 27.3104C37.5517 22.5618 39.9619 18.2263 43.9953 15.7137L45.8012 18.6103C42.7731 20.4964 40.9655 23.7498 40.9655 27.3104C40.9655 30.0073 42.0033 32.5522 43.8911 34.4776ZM51.2069 17.069C50.1691 17.069 49.1433 17.2243 48.1601 17.5298L47.1462 14.2697C48.4588 13.8617 49.8243 13.6552 51.2069 13.6552V17.069Z",
    fill: "#F68C33"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7957 15.2972C86.4594 14.3003 86.0771 13.3086 85.6589 12.3494L82.5284 13.7098C82.9074 14.582 83.2539 15.4832 83.5611 16.3896L86.7957 15.2972Z",
    fill: "#F68C33"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3448 27.3104L85.3431 27.6842L88.7569 27.7268L88.7586 27.3104C88.7586 26.3869 88.7245 25.4737 88.6596 24.5674L85.2544 24.8149C85.3141 25.6393 85.3448 26.4706 85.3448 27.3104Z",
    fill: "#F68C33"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9284 21.9626L88.3012 21.43C88.1373 20.3888 87.9274 19.3459 87.6782 18.332L84.3634 19.1479C84.5904 20.0679 84.7799 21.0153 84.9284 21.9626Z",
    fill: "#F68C33"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8836 13.7115L16.7532 12.3511C16.3367 13.3104 15.9544 14.3021 15.6164 15.2989L18.851 16.3931C19.1582 15.485 19.5064 14.582 19.8836 13.7115Z",
    fill: "#F68C33"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0505 19.1479L14.7357 18.332C14.4865 19.3459 14.2765 20.3888 14.1126 21.43L17.4855 21.9626C17.634 21.0153 17.8234 20.0679 18.0505 19.1479Z",
    fill: "#F68C33"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0707 27.6842L17.069 27.3104C17.069 26.4706 17.0997 25.6393 17.1594 24.8149L13.7542 24.5674C13.6893 25.4737 13.6552 26.3869 13.6552 27.3104L13.6569 27.7268L17.0707 27.6842Z",
    fill: "#F68C33"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValue21);
export default __webpack_public_path__ + "static/media/value21.b099a21a5c51b10446368c30c8c68519.svg";
export { ForwardRef as ReactComponent };